module.exports = __webpack_public_path__ + "static/media/bum1_munich.d140e9cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/bum1_munich.jpg
// module id = 441
// module chunks = 0